export const CAR_POSITION_VIEW = "CAR_POSITION_VIEW";
export const CONFIRM_ORDER_VIEW = "CONFIRM_ORDER_VIEW";
export const CUSTOMER_DETAILS_VIEW = "CUSTOMER_DETAILS_VIEW";
export const DAMAGE_REASON_VIEW = "DAMAGE_REASON_VIEW";
export const ESTIMATE_PRICE_VIEW = "ESTIMATE_PRICE_VIEW";
export const SEEKING_RESPONDER_VIEW = "SEEKING_RESPONDER_VIEW";
export const USER_TERMS_VIEW = "USER_TERMS_VIEW";
export const TMA_CAR_TERMS_VIEW = "TMA_CAR_TERMS_VIEW";
export const WELCOME_SCREEN_VIEW = "WELCOME_SCREEN_VIEW";
